// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3G4vL","label":"CategoryService_label__3TZtE","location":"CategoryService_location__1Oahh"};